import { Drawer, Box, CircularProgress } from '@mui/material'

import { useState, useEffect } from 'react'

import InfoScreen from './InfoScreen';
import ExistingContactOtp from './ExistingContactOtp';
import NewContactFields from './NewContactFields';
import NewContactOtp from './NewContactOtp';
import UpdateInfo from './UpdateInfo';
import NotifyInfo from './NotifyInfo';

import { useSelector } from "react-redux"
import ApiClient from "../../utilities/apiClient"
import AppConfig from "../../AppConfig"

const ContactUpdateDrawer = ({ open, onClose, maskedValue, fieldType, userInfo }) => {

    const apiToken = useSelector(state => state.auth.apiToken)

    const [step, setStep] = useState(1)
    const [newContactValue, setNewContactValue] = useState("")

    const [updateStatus, setUpdateStatus] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (open) {
            setLoading(true)
            fetchUpdateStatus()
        }
    }, [open])

    const fetchUpdateStatus = async () => {
        const emailPayload = {
            clientId: userInfo?.CLIENT_ID,
            updateType: 'email'
        }

        const mobilePayload = {
            clientId: userInfo?.CLIENT_ID,
            updateType: 'mobile'
        }

        try {

            const apiClient = new ApiClient(apiToken)

            const [emailRes, mobileRes] = await Promise.all([
                apiClient.fetchData(AppConfig.api.Profile.updateStats, "POST", emailPayload),
                apiClient.fetchData(AppConfig.api.Profile.updateStats, "POST", mobilePayload)
            ])

            const emailStatus = emailRes?.data?.requestData?.verification_status
            const mobileStatus = mobileRes?.data?.requestData?.verification_status

            const emailPending = emailStatus === 'pending'
            const mobilePending = mobileStatus === 'pending'

            if (fieldType === 'mobile') {
                if (emailPending) {
                    // Block mobile update
                    setUpdateStatus({
                        update_type: 'email',
                        verification_status: 'pending'
                    })
                } else if (mobilePending) {
                    // Show UpdateInfo for mobile
                    setUpdateStatus(mobileRes.data.requestData)
                } else {
                    // full mobile update
                    setUpdateStatus(null)
                }
            }

            if (fieldType === 'email') {
                if (mobilePending) {
                    setUpdateStatus({
                        update_type: 'mobile',
                        verification_status: 'pending'
                    })
                } else if (emailPending) {
                    setUpdateStatus(emailRes.data.requestData)
                } else {
                    setUpdateStatus(null)
                }
            }

        } catch (error) {
            console.error("Error during API request (Try block) :", error)
        } finally {
            setLoading(false)
        }
    }

    const next = () => setStep((prev) => prev + 1)

    return (
        <Drawer anchor="right" open={open} onClose={() => {
            onClose()
            setStep(1)
        }}
        >
            <Box sx={{ width: 350, p: 3, backgroundColor: "#0B1420", height: "100%", mt: 7 }}>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <CircularProgress color="primary" />
                    </Box>
                        
                ) : updateStatus && updateStatus.verification_status === "pending" ? (
                    updateStatus.update_type === fieldType
                        ? <UpdateInfo onClose={onClose} fieldType={fieldType} />
                        : <NotifyInfo onClose={onClose} fieldType={fieldType} />
                ) : (
                    <>
                        {step === 1 && <InfoScreen onNext={next} maskedValue={maskedValue} fieldType={fieldType} onClose={onClose} />}
                        {step === 2 && <ExistingContactOtp onNext={next} maskedValue={maskedValue} fieldType={fieldType} onClose={onClose} />}
                        {step === 3 && <NewContactFields onNext={next} fieldType={fieldType} setNewContactValue={setNewContactValue} onClose={onClose} />}
                        {step === 4 && <NewContactOtp fieldType={fieldType} newContactValue={newContactValue} onClose={onClose} />}
                    </>
                )}
            </Box>

        </Drawer>
    )
}

export default ContactUpdateDrawer
